import { render, staticRenderFns } from "./DownloadInvoice.vue?vue&type=template&id=4d28156b&scoped=true"
import script from "./DownloadInvoice.vue?vue&type=script&lang=js"
export * from "./DownloadInvoice.vue?vue&type=script&lang=js"
import style0 from "./DownloadInvoice.vue?vue&type=style&index=0&id=4d28156b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28156b",
  null
  
)

export default component.exports